import React, { Component } from 'react';
import {ICDBPageProps} from "../../../../utils/ICDBPageProps";
import {MailroomSchoolConfig} from "../../../../models/MailroomSchoolConfig";
import LoadingPage from "../../../LoadingPage";
import {Redirect} from "react-router";

interface MisFetchRedirectPageProps extends ICDBPageProps
{
    tenantId: string;
    schoolCode: string;
}

interface MisFetchRedirectPageState {
    mailroomConfig?: MailroomSchoolConfig;
}

export default class MisFetchRedirectPage extends Component<MisFetchRedirectPageProps, MisFetchRedirectPageState> {
    static displayName = MisFetchRedirectPage.name;

    constructor(props: MisFetchRedirectPageProps) {
        super(props);

        this.state = {
            mailroomConfig: undefined
        }
    }

    async componentDidMount() {

        const mailroomConfig = await this.props.apiService.getMailroomSchoolConfig(this.props.tenantId, this.props.schoolCode);

        this.setState({
            mailroomConfig: mailroomConfig
        });

    }

    async componentDidUpdate(prevProps: Readonly<MisFetchRedirectPageProps>, prevState: any): Promise<void> {

    }

    render()
    {
        
        if(this.state.mailroomConfig === undefined)
        {
            return <LoadingPage></LoadingPage>
        }
    
        return <Redirect to={`/cdb-admin/mis-fetch/${this.props.tenantId}/${this.props.schoolCode}/${this.state.mailroomConfig.misDataServiceType}`}/>;
    }
}